import { Typography } from "./typography";
import { cn } from "../../../lib/utils";
export function InputLabel({
  children,
  className,
  isOptional = false
}: {
  children: string;
  className?: string;
  isOptional?: boolean;
}) {
  return (
    <Typography variant="label2" className={cn("flex gap-2 items-center", className)}>
      {children}
      {isOptional && (
        <Typography component="span" variant="body3" color="zinc400" className="font-light">
          Optional
        </Typography>
      )}
    </Typography>
  );
}
